import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSlide, UserTutorialStatusType } from "../../tutorial.models";

export const SCHEDULE_SLIDE_NAV: TutorialSlide[] = [
    {
        key: 'Patient-Schedule',
        // title: 'Learn How to use MedicAI',
        messages: [{ text: "Click on the video above to learn how to use the MedicAI Calendar to schedule appointments and procedures!" }],
        videoUrl: 'https://www.youtube.com/watch?v=oVArAPJCjww',
        thumbnailUrl: 'assets/patient-schedule-thumbnail.png',
        tutorialStatusType: UserTutorialStatusType.SCHEDULING,
        hideDoNotShowAgain: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.START_PATIENT_SIDE_NAV_TUTORIAL
            },
        ],
        hideConditions: [
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
        ],
    },

];